export default "__VITE_ASSET__b64b6975__"